<app-rightimagepagewrapper [src]="activeTenant?.pageimage ?? ''">
  @if (!activeTenant?.insurer) {
    <app-title [title]="'generic.welcome' | translate"></app-title>
  } @else {
    @if (activeTenant?.name === 'Animal Friends') {
      <app-title
        [title]="
          ('generic.create_your' | translate) +
          ' Joii X ' +
          activeTenant?.name +
          ' ' +
          ('generic.insurance_account' | translate)
        "
      ></app-title>
    } @else {
      <app-title
        [title]="('generic.create_your' | translate) + ' Joii X ' + activeTenant?.name + ' account'"
      ></app-title>
    }
  }
  @if (error) {
    <app-banner title="Register Error" [description]="error" (dismissclick)="clearError()"></app-banner>
  }
  @if (activeTenant?.emailandpassword && registerform) {
    <form class="form" [formGroup]="registerform" (ngSubmit)="onSubmitRegister(registerform)">
      <div class="input-group">
        <app-input
          name="email"
          formControlName="email"
          [label]="
            (providerParam() === 'cruftsclub' ? 'generic.crufts_club_membership_email' : 'generic.email_address')
              | translate
          "
          [placeholder]="'generic.enter_email' | translate"
          [span]="6"
        ></app-input>
        @if (activeTenant?.insurer) {}
      </div>
      @if (activeTenant?.name !== 'Joii') {
        <span class="text-xs text-gray-500">*Email address must match the email used for your insurance policy.</span>
      }
      <div>
        <div class="input-group">
          <app-input
            name="password"
            formControlName="password"
            [label]="'generic.password' | translate"
            [type]="showPassword ? 'text' : 'password'"
            [placeholder]="'generic.enter_password' | translate"
            [span]="6"
          >
            <button
              (click)="togglePasswordVisibility()"
              type="button"
              class="absolute inset-y-0 right-0 flex items-center pr-3"
            >
              <svg [lucideIcon]="showPassword ? EyeIcon : EyeOffIcon" [size]="24" [class]="'dark:text-ds-text-base'" />
            </button>
          </app-input>
        </div>
        <!-- Dynamic Password Requirement Checklist -->
        <div class="pt-2 space-y-2">
          <!-- Min Length -->
          @if (passwordPolicy()?.customStrengthOptions?.minPasswordLength) {
            <div class="flex items-center">
              <svg
                [lucideIcon]="isLengthValid ? CircleCheckIcon : CircleIcon"
                [size]="24"
                [class]="isLengthValid ? 'mr-2 text-cyan-700' : 'mr-2'"
              />
              <span class="text-sm">
                Minimum {{ passwordPolicy()?.customStrengthOptions?.minPasswordLength }} characters
              </span>
            </div>
          }
          <!-- Lowercase -->
          @if (passwordPolicy()?.customStrengthOptions?.containsLowercaseLetter) {
            <div class="flex items-center">
              <svg
                [lucideIcon]="hasLowercase ? CircleCheckIcon : CircleIcon"
                [size]="24"
                [class]="hasLowercase ? 'mr-2 text-cyan-700' : 'mr-2'"
              />
              <span class="text-sm">At least one lowercase letter</span>
            </div>
          }
          <!-- Uppercase -->
          @if (passwordPolicy()?.customStrengthOptions?.containsUppercaseLetter) {
            <div class="flex items-center">
              <svg
                [lucideIcon]="hasUppercase ? CircleCheckIcon : CircleIcon"
                [size]="24"
                [class]="hasUppercase ? 'mr-2 text-cyan-700' : 'mr-2'"
              />
              <span class="text-sm">At least one uppercase letter</span>
            </div>
          }
          <!-- Number -->
          @if (passwordPolicy()?.customStrengthOptions?.containsNumericCharacter) {
            <div class="flex items-center">
              <svg
                [lucideIcon]="hasNumber ? CircleCheckIcon : CircleIcon"
                [size]="24"
                [class]="hasNumber ? 'mr-2 text-cyan-700' : 'mr-2'"
              />
              <span class="text-sm">At least one number</span>
            </div>
          }
          <!-- Special Character -->
          @if (passwordPolicy()?.customStrengthOptions?.containsNonAlphanumericCharacter) {
            <div class="flex items-center">
              <svg
                [lucideIcon]="hasSpecialChar ? CircleCheckIcon : CircleIcon"
                [size]="24"
                [class]="hasSpecialChar ? 'mr-2 text-cyan-700' : 'mr-2'"
              />
              <span class="text-sm"> At least one special character </span>
            </div>
          }
        </div>
      </div>
      <app-form-submission-button
        [form]="registerform"
        [loading]="loading"
        [buttonText]="'generic.create_account' | translate"
      ></app-form-submission-button>
    </form>
  }
  @if (activeTenant?.google) {
    <button class="google-btn w-full mt-3" (click)="google()">
      @if (!loading) {
        <span>Continue With Google</span>
      }
      @if (loading) {
        <span>loading...</span>
      }
    </button>
  }
  @if (providerswitcher) {
    <div class="mt-3">
      <app-centertextbutton
        [text]="'Not with ' + (activeTenant?.name ?? '') + '?'"
        linktext="Insured with one of our partners"
        (linkclick)="anothertenant()"
      ></app-centertextbutton>
    </div>
  }
  <div class="flex items-center justify-center mt-10">
    <div class="w-full h-[1px] bg-gray-300"></div>
    <div class="mx-4 text-gray-500">Or</div>
    <div class="w-full h-[1px] bg-gray-300"></div>
  </div>
  <div class="mt-10">
    <app-centertextbutton
      [text]="'Already have an account?'"
      linktext="Login here"
      (linkclick)="login()"
    ></app-centertextbutton>
  </div>
</app-rightimagepagewrapper>
